import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './footer-copyright.scss.js';

class FooterCopyright extends s {
    constructor() {
        super(...arguments);
        this.text = '© 2025 ConvaTec Inc.';
    }
    render() {
        return $ `<div class="footer-copyright"><p class="footer-copyright__text">${this.text}</p></div>`;
    }
}
FooterCopyright.styles = css_248z;
__decorate([
    e({ type: String })
], FooterCopyright.prototype, "text", void 0);
customElements.define('footer-copyright', FooterCopyright);

export { FooterCopyright };
